{
  "AUTOMATION": {
    "HEADER": "Automatizacija",
    "DESCRIPTION": "Automatizacija može zamijeniti i pojednostaviti postojeće procese koji zahtijevaju ručni rad, kao što su dodavanje oznaka i dodjela razgovora najprikladnijem agentu. Tako se tim može usredotočiti na ono u čemu je najbolji i trošiti manje vremena na rutinske zadatke.",
    "LEARN_MORE": "Saznajte više o automatizaciji",
    "HEADER_BTN_TXT": "Dodaj pravilo automatizacije",
    "LOADING": "Dohvaćanje pravila automatizacije",
    "ADD": {
      "TITLE": "Dodaj pravilo automatizacije",
      "SUBMIT": "Izradi",
      "CANCEL_BUTTON_TEXT": "Odustani",
      "FORM": {
        "NAME": {
          "LABEL": "Naziv pravila",
          "PLACEHOLDER": "Unesite naziv pravila",
          "ERROR": "Naziv je obavezan"
        },
        "DESC": {
          "LABEL": "Opis",
          "PLACEHOLDER": "Unesite opis pravila",
          "ERROR": "Opis je obavezan"
        },
        "EVENT": {
          "LABEL": "Događaj",
          "PLACEHOLDER": "Odaberite jednu mogućnost",
          "ERROR": "Događaj je obavezan"
        },
        "PHASE": {
          "LABEL": "Faza"
        },
        "ORDER": {
          "LABEL": "Redoslijed",
          "ERROR": "Redoslijed je obavezan"
        },
        "CONDITIONS": {
          "LABEL": "Uvjeti"
        },
        "ACTIONS": {
          "LABEL": "Radnje"
        }
      },
      "CONDITION_BUTTON_LABEL": "Dodaj uvjet",
      "ACTION_BUTTON_LABEL": "Dodaj radnju",
      "API": {
        "SUCCESS_MESSAGE": "Pravilo automatizacije uspješno je dodano",
        "ERROR_MESSAGE": "Nije moguće stvoriti pravilo automatizacije. Pokušajte ponovno kasnije"
      }
    },
    "LIST": {
      "TABLE_HEADER": {
        "PHASE": "Faza",
        "ORDER": "Redoslijed",
        "NAME": "Ime",
        "DESCRIPTION": "Opis",
        "ACTIVE": "Aktivno",
        "CREATED_ON": "Stvoreno",
        "WAIT": "Čekanje"
      },
      "404": "Nema pronađenih pravila automatizacije",
      "TABS": {
        "ALL": "Sve",
        "INSTANT": "Pri događaju",
        "DELAYED": "S odgodom"
      },
      "WAITS": "Čeka {duration}"
    },
    "DELETE": {
      "TITLE": "Izbriši pravilo automatizacije",
      "SUBMIT": "Izbriši",
      "CANCEL_BUTTON_TEXT": "Odustani",
      "CONFIRM": {
        "TITLE": "Potvrdi brisanje",
        "MESSAGE": "Jeste li sigurni da želite izbrisati ",
        "YES": "Da, izbriši",
        "NO": "Ne, zadrži"
      },
      "API": {
        "SUCCESS_MESSAGE": "Pravilo automatizacije uspješno je izbrisano",
        "ERROR_MESSAGE": "Nije moguće izbrisati pravilo automatizacije. Pokušajte ponovno kasnije"
      }
    },
    "EDIT": {
      "TITLE": "Uredi pravilo automatizacije",
      "SUBMIT": "Ažuriraj",
      "CANCEL_BUTTON_TEXT": "Odustani",
      "API": {
        "SUCCESS_MESSAGE": "Pravilo automatizacije uspješno je ažurirano",
        "ERROR_MESSAGE": "Nije moguće ažurirati pravilo automatizacije. Pokušajte ponovno kasnije"
      }
    },
    "CLONE": {
      "TOOLTIP": "Kloniraj",
      "API": {
        "SUCCESS_MESSAGE": "Automatizacija uspješno je klonirana",
        "ERROR_MESSAGE": "Nije moguće klonirati pravilo automatizacije. Pokušajte ponovno kasnije"
      }
    },
    "FORM": {
      "EDIT": "Uredi",
      "CREATE": "Izradi",
      "DELETE": "Izbriši",
      "CANCEL": "Odustani",
      "RESET_MESSAGE": "Promjenom vrste događaja poništit će se uvjeti i radnje koje ste dodali u nastavku"
    },
    "CONDITION": {
      "DELETE_MESSAGE": "Za spremanje je potreban barem jedan uvjet",
      "CONTACT_CUSTOM_ATTR_LABEL": "Prilagođeni atributi kontakta",
      "CONVERSATION_CUSTOM_ATTR_LABEL": "Prilagođeni atributi razgovora"
    },
    "ACTION": {
      "DELETE_MESSAGE": "Za spremanje je potrebna barem jedna radnja",
      "TEAM_MESSAGE_INPUT_PLACEHOLDER": "Ovdje unesite poruku",
      "TEAM_DROPDOWN_PLACEHOLDER": "Odaberite timove",
      "EMAIL_INPUT_PLACEHOLDER": "Unesite e-poštu",
      "URL_INPUT_PLACEHOLDER": "Unesite URL",
      "SENDER_DROPDOWN_PLACEHOLDER": "Odaberite sandučić e-pošte i adresu pošiljatelja",
      "SUBJECT_INPUT_PLACEHOLDER": "Predmet e-pošte",
      "SMS_INBOX_DROPDOWN_PLACEHOLDER": "Odaberite SMS sandučić s kojeg se šalje",
      "SMS_MESSAGE_INPUT_PLACEHOLDER": "Unesite tekst SMS-a",
      "SMS_COUNTER": "{length}/{limit} znakova, {segments} SMS (prije popunjavanja varijabli)"
    },
    "TOGGLE": {
      "ACTIVATION_TITLE": "Aktiviraj pravilo automatizacije",
      "DEACTIVATION_TITLE": "Deaktiviraj pravilo automatizacije",
      "ACTIVATION_DESCRIPTION": "Ova radnja aktivirat će pravilo automatizacije '{automationName}'. Jeste li sigurni da želite nastaviti?",
      "DEACTIVATION_DESCRIPTION": "Ova radnja deaktivirat će pravilo automatizacije '{automationName}'. Jeste li sigurni da želite nastaviti?",
      "ACTIVATION_SUCCESFUL": "Pravilo automatizacije uspješno je aktivirano",
      "DEACTIVATION_SUCCESFUL": "Pravilo automatizacije uspješno je deaktivirano",
      "ACTIVATION_ERROR": "Nije moguće aktivirati automatizaciju. Pokušajte ponovno kasnije",
      "DEACTIVATION_ERROR": "Nije moguće deaktivirati automatizaciju. Pokušajte ponovno kasnije",
      "CONFIRMATION_LABEL": "Da",
      "CANCEL_LABEL": "Ne"
    },
    "ATTACHMENT": {
      "UPLOAD_ERROR": "Nije moguće prenijeti privitak. Pokušajte ponovno",
      "LABEL_IDLE": "Prenesi privitak",
      "LABEL_UPLOADING": "Prenosim...",
      "LABEL_UPLOADED": "Uspješno preneseno",
      "LABEL_UPLOAD_FAILED": "Prijenos nije uspio"
    },
    "ERRORS": {
      "ATTRIBUTE_KEY_REQUIRED": "Ključ atributa je obavezan",
      "FILTER_OPERATOR_REQUIRED": "Operator filtra je obavezan",
      "VALUE_REQUIRED": "Vrijednost je obavezna",
      "VALUE_MUST_BE_BETWEEN_0_AND_998": "Vrijednost mora biti između 0 i 998",
      "ACTION_PARAMETERS_REQUIRED": "Parametri radnje su obavezni",
      "ATLEAST_ONE_CONDITION_REQUIRED": "Potreban je barem jedan uvjet",
      "ATLEAST_ONE_ACTION_REQUIRED": "Potrebna je barem jedna radnja",
      "ORDER_REQUIRED": "Redoslijed je obavezan",
      "ORDER_MUST_BE_AT_LEAST_ONE": "Redoslijed mora biti najmanje 1"
    },
    "ACTION_NOTICES": {
      "SKIP_AUTO_PRIORITY": "Ova akcija radi samo kada je faza pravila postavljena na 'Prije označavanja'.",
      "SKIP_AUTO_LABELING": "Ova akcija radi samo kada je faza pravila postavljena na 'Prije označavanja'.",
      "MOVE_CONVERSATION_TO_INBOX": "U e-mail sandučić mogu se premjestiti samo e-mail razgovori i razgovori s web chata, a web chat samo ako kontakt ima adresu e-pošte. Inače se razgovor ne premješta, već se dodaje privatna bilješka.",
      "SEND_MESSAGE_IN_NEW_CONVERSATION": "Pokreće novi razgovor s kontaktom u odabranom sandučiću e-pošte, šalje mu poruku e-poštom i označava razgovor riješenim. To se događa svaki put kada se pravilo pokrene. Ako kontakt nema adresu e-pošte, ništa se ne šalje i umjesto toga dodaje se privatna bilješka.",
      "SEND_SMS_IN_NEW_CONVERSATION": "Pokreće novi razgovor s kontaktom u odabranom SMS sandučiću, šalje mu poruku kao SMS i označava razgovor riješenim. To se događa svaki put kada se pravilo pokrene. Poruka je običan tekst bez privitaka. Ako kontakt nema telefonski broj, ništa se ne šalje i umjesto toga dodaje se privatna bilješka."
    },
    "NOTICES": {
      "AI_PROMPT": "Svaka pojedinačna evaluacija se naplaćuje.",
      "INCOMING_MESSAGES_COUNT": "Ovo se odnosi na broj dolaznih poruka u razgovoru.",
      "OUTGOING_MESSAGES_COUNT": "Ovo se odnosi na broj odlaznih poruka u razgovoru."
    },
    "PHASE": {
      "BEFORE_LABELING": "Prije označavanja",
      "AFTER_LABELING": "Nakon označavanja"
    },
    "NONE_OPTION": "Nijedno",
    "MESSAGE_TYPE_VALUES": {
      "INCOMING": "Dolazna poruka",
      "OUTGOING": "Odlazna poruka",
      "PRIVATE": "Privatna bilješka",
      "AI_SUMMARY": "AI sažetak"
    },
    "YES_NO_VALUES": {
      "YES": "Da",
      "NO": "Ne"
    },
    "MESSAGE_SOURCE_TYPE_VALUES": {
      "FACEBOOK_MESSENGER": "Facebook Messenger",
      "INSTAGRAM_DM": "Izravna poruka na Instagramu",
      "FACEBOOK_COMMENT": "Komentar na Facebooku"
    },
    "EVENTS": {
      "CONVERSATION_CREATED": "Razgovor kreiran",
      "CONVERSATION_UPDATED": "Razgovor ažuriran",
      "MESSAGE_CREATED": "Poruka kreirana",
      "CONVERSATION_OPENED": "Razgovor otvoren",
      "CONVERSATION_RESOLVED": "Razgovor riješen",
      "PHONE_CALL_FINISHED": "Poziv završen"
    },
    "ACTIONS": {
      "ASSIGN_AGENT": "Dodijeli agentu",
      "ASSIGN_TEAM": "Dodijeli timu",
      "ADD_LABEL": "Dodaj oznaku",
      "REMOVE_LABEL": "Ukloni oznaku",
      "SEND_EMAIL_TO_TEAM": "Pošalji e-mail timu",
      "SEND_EMAIL_TRANSCRIPT": "Pošalji transkript e-mailom",
      "SEND_EMAIL_TRANSCRIPT_WITH_DETAILS": "Pošalji detaljni transkript e-mailom",
      "MUTE_CONVERSATION": "Utišaj razgovor",
      "SNOOZE_CONVERSATION": "Odgodi razgovor",
      "RESOLVE_CONVERSATION": "Riješi razgovor",
      "OPEN_CONVERSATION": "Otvori razgovor",
      "SEND_WEBHOOK_EVENT": "Pošalji webhook događaj",
      "SEND_ATTACHMENT": "Pošalji privitak",
      "SEND_MESSAGE": "Pošalji poruku",
      "ADD_NOTE": "Dodaj bilješku",
      "CHANGE_PRIORITY": "Promijeni prioritet",
      "ADD_SLA": "Dodaj SLA",
      "SKIP_AUTO_PRIORITY": "Preskoči automatski prioritet",
      "SKIP_AUTO_LABELING": "Preskoči automatsko označavanje",
      "AUTO_TRANSLATE": "Prevedi poruku",
      "AUTO_TRANSLATE_CONVERSATION": "Prevedi razgovor",
      "MOVE_CONVERSATION_TO_INBOX": "Premjesti razgovor u sandučić",
      "SEND_MESSAGE_IN_NEW_CONVERSATION": "Pošalji poruku u novom razgovoru",
      "SEND_SMS_IN_NEW_CONVERSATION": "Pošalji SMS u novom razgovoru",
      "STOP_PROCESSING_RULES": "Zaustavi obradu pravila"
    },
    "ATTRIBUTES": {
      "EXTENSION": "Pozvani lokal",
      "AI_FILTER": "AI filter",
      "MESSAGE_TYPE": "Vrsta poruke",
      "MESSAGE_CONTAINS": "Sadržaj poruke",
      "EMAIL": "E-mail",
      "INBOX": "Sandučić",
      "CHANNEL_TYPE": "Vrsta sandučića",
      "CONVERSATION_LANGUAGE": "Jezik razgovora",
      "PHONE_NUMBER": "Telefonski broj",
      "STATUS": "Status",
      "BROWSER_LANGUAGE": "Jezik preglednika",
      "MAIL_SUBJECT": "Naslov e-maila",
      "COUNTRY_NAME": "Država",
      "MARKETPLACE_COUNTRY": "Država marketplacea",
      "REFERER_LINK": "Poveznica preporuke",
      "ASSIGNEE_NAME": "Dodijeljena osoba",
      "TEAM_NAME": "Tim",
      "PRIORITY": "Prioritet",
      "CALL_DIRECTION": "Smjer poziva",
      "MISSED_CALL": "Propušteni poziv",
      "MISSED_CALL_COUNT": "Broj propuštenih poziva",
      "MESSAGE_SOURCE_TYPE": "Vrsta izvora poruke",
      "INCOMING_MESSAGE_COUNT": "Broj dolaznih poruka",
      "OUTGOING_MESSAGE_COUNT": "Broj odlaznih poruka",
      "LABEL": "Oznaka",
      "EMAIL_RECIPIENTS": "Primatelj e-maila",
      "EMAIL_AUTO_REPLY": "E-mail je automatski odgovor",
      "ATTACHMENT_EXTENSION": "Ekstenzija privitka",
      "WORKING_HOURS": "Unutar radnog vremena",
      "AGENT_REPLIED": "Agent je odgovorio od promjene statusa"
    },
    "WAIT": {
      "RUN_LABEL": "Pokreni radnje",
      "INSTANT": "Pri događaju",
      "DELAYED": "S odgodom",
      "TRIGGER_LABEL": "Čekaj dok",
      "TRIGGERS": {
        "CONVERSATION_STATUS": "Razgovor ostaje u statusu",
        "CUSTOMER_UNRESPONSIVE": "Kupac ne odgovara agentu",
        "AGENT_UNRESPONSIVE": "Kupac ne dobiva odgovor agenta"
      },
      "STATUS_LABEL": "Status",
      "STATUSES": {
        "OPEN": "Otvoren",
        "PENDING": "Na čekanju",
        "SNOOZED": "Odgođen",
        "RESOLVED": "Riješen"
      },
      "DELAY_LABEL": "Vrijeme čekanja",
      "DELAY_ERROR": "Unesite vrijeme čekanja između 1 minute i 30 dana",
      "DURATION": {
        "MINUTES": "{count} min",
        "HOURS": "{count} h",
        "DAYS": "{count} d"
      },
      "EXPLANATION": {
        "CONVERSATION_STATUS": "Radnje se pokreću kada je razgovor u statusu {status} tijekom {duration}. Promjena statusa prije toga ih otkazuje. Oznake, radno vrijeme i odgovori agenta provjeravaju se kada čekanje završi.",
        "CUSTOMER_UNRESPONSIVE": "Radnje se pokreću kada kupac {duration} nije odgovorio na poruku agenta. Odgovor kupca ih otkazuje; nova poruka agenta ponovno pokreće čekanje.",
        "AGENT_UNRESPONSIVE": "Radnje se pokreću kada kupac čeka {duration} bez odgovora agenta. Odgovor agenta ih otkazuje."
      }
    }
  }
}
